import { render, staticRenderFns } from "./DefTextList.vue?vue&type=template&id=eb904b36&"
import script from "./DefTextList.vue?vue&type=script&lang=js&"
export * from "./DefTextList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports